import { Component, Input, OnInit } from '@angular/core';
import {
  ComponentRendering,
  Field,
  Item
} from '@sitecore-jss/sitecore-jss/layout';
import { ReportTableComponent } from '../report-table/report-table.component';
import { REPORTING_EVENTS } from './../../services/reporting.service';
import { ICurrency } from './../../../shared/interfaces/currency.interface';
import { GetItemListFieldsService } from '../../../shared/services/get-item-list-fields.service';
import { DataSubscriptionService } from '../../../shared/services/data-subscription.service';

interface ITransferData {
  refN: string;
  beneficiary: string;
  amount: ICurrency;
  approveeId: string;
  approvedDate: Date;
  createId: string;
  createDate: Date;
  modifyId: string;
  modifyDate: Date;
  preApproveeId: string;
  preApproveeDate: Date;
}

@Component({
  selector: 'ab-money-transfer-table',
  templateUrl: './money-transfer-table.component.html',
  styleUrls: ['./money-transfer-table.component.scss']
})
export class MoneyTransferTableComponent extends ReportTableComponent
  implements OnInit {
  @Input() rendering: ComponentRendering;
  public declare items: Array<ITransferData>;
  public fields: { [key: string]: { [name: string]: Field } };

  constructor(
    private getItemListFieldsService: GetItemListFieldsService,
    dataSubscriptionService: DataSubscriptionService
  ) {
    super(dataSubscriptionService);
  }

  ngOnInit() {
    this.subscribe(REPORTING_EVENTS.MONEY_TRANSFER);
    this.columns = (this.rendering.fields.items as Array<any>)
      .filter(item => item.displayName !== 'Metadata')
      .map(column => {
        return column.fields.label.value;
      });

    this.fields = this.getItemListFieldsService.getFields(
      (this.rendering.fields.items as Item[]).filter(
        o => o.name === 'Metadata'
      )[0]
    );
  }
}
